<template>
  <button
    type="button"
    class="ds-modal-close"
    data-testid="ds-modal-close"
    @click="onCloseModal"
  >
    <DsCloseOutlineIcon class="ds-modal-close-icon" />
  </button>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { DsModalHandler } from "../../helpers";
import type { Ref } from "vue";

import { DsCloseOutlineIcon } from "../icon";

defineOptions({
  name: "DsModalCloseButton",
});

const modalId = inject("modalId") as Ref<string>;

function onCloseModal(): void {
  DsModalHandler.close(modalId.value);
}
</script>

<style lang="scss" scoped>
.ds-modal-close {
  @apply w-10 h-10 rounded-lg cursor-pointer text-gray-900 flex items-center justify-center hover:bg-gray-100;

  &-icon {
    @apply w-5 h-5;
  }
}
</style>
